import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function M_FooterBox() {
  const goTop = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <footer className='bg-[#F8F9FA] flex flex-col justify-start items-start pb-[20px]'>
      <div className='w-full flex flex-col justify-start items-start text-[#222222] font-[400] py-[20px] px-[24px]'>
        <div className='w-full mx-auto flex flex-col justify-start items-center mb-[30px]'>
          <div className='w-full mb-[30px] relative'>
            <h1
              className='h-[30px] mb-[24px] cursor-pointer'
              onClick={() => {
                window.location.reload();
                window.scrollTo({ top: 0 });
              }}
            >
              <img
                src='/imgs/icons/logo_footer.png'
                alt='한국영업경제인협회 로고'
                className='h-full object-contain '
              />
            </h1>
            <div className='w-full flex flex-col justify-start items-start gap-[12px] leading-[100%]'>
              <p>
                <span className="relative pr-[6px] mr-[6px] after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:right-0 after:top-0 after:bottom-0 after:my-auto after:bg-[#222222]">
                  대표자 : 최용민
                </span>
                <span>사업자 등록번호 : 214-82-79500</span>
              </p>
              <address className='not-italic leading-[150%]'>
                <address className='not-italic'>
                  주소 : (04790) 서울특별시 성동구 아차산로 49, 1404호
                </address>
              </address>
              <p>통신판매업신고 : 제 2024-서울성동-1541호</p>
              <p>
                {/* <span className="relative pr-[6px] mr-[6px] after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:right-0 after:top-0 after:bottom-0 after:my-auto after:bg-white">
                  개인정보보호책임자 : 김영진
                </span> */}
                <span>이메일 : info@fks.co.kr</span>
              </p>
              <Link
                to='https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2148279500'
                target='_blank'
                className='underline'
              >
                사업자 정보확인
              </Link>
            </div>
          </div>
          <div className='w-full flex justify-center items-stretch gap-[8px]'>
            <div className='w-[calc(45%-4px)] tiny:w-[calc(40%-4px)] text-white flex flex-col justify-start items-start gap-[8px]'>
              <button
                onClick={() => {
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.carsayo.fks',
                  );
                }}
                className='w-full h-[calc(50%-4px)] flex justify-start items-center gap-[10px] tiny:gap-[6px] py-[15px] px-[12px] max-h-[54px] bg-white border border-[#E5E5EC] text-[#111111] rounded-[6px]'
              >
                <img
                  src='/imgs/icons/google.webp'
                  alt='플레이스토어 아이콘'
                  className='w-[24px] object-contain tiny:w-[20px]'
                />
                <span className='text-[13px] '>Play Store</span>
              </button>
              <button
                onClick={() => {
                  window.open(
                    'https://apps.apple.com/us/app/%ED%95%9C%EA%B5%AD%EC%98%81%EC%97%85%EA%B2%BD%EC%A0%9C[…]B4%EC%BB%A4%EB%A8%B8%EC%8A%A4-%ED%8F%AC%ED%84%B8/id6737255285',
                  );
                }}
                className='w-full h-[calc(50%-4px)] flex justify-start items-center gap-[10px] tiny:gap-[6px] py-[15px] px-[12px] max-h-[54px] bg-white border border-[#E5E5EC] text-[#111111] rounded-[6px]'
              >
                <img
                  src='/imgs/icons/apple_logo.png'
                  alt='애플스토어 아이콘'
                  className='w-[24px] object-contain tiny:w-[20px]'
                />
                <span className='text-[13px] mt-[2px]'>App Store</span>
              </button>
            </div>
            <div className='w-[calc(55%-4px)] tiny:w-[calc(60%-4px)] p-[14px] text-[#222222] bg-[#F2F4F6] rounded-[6px] flex flex-col justify-start items-start'>
              <div className='w-full'>
                <div className='flex justify-start items-center gap-[8px] mb-[17px]'>
                  <Link
                    to='tel:16669295'
                    className='text-[14px] leading-[14px] font-[600] break-words tiny:text-[12px]'
                  >
                    1666-9295
                  </Link>
                </div>
                <div className='flex flex-col justify-start items-start gap-[10px] text-[12px] leading-[100%]'>
                  <p className='flex flex-wrap justify-start items-center'>
                    <span className='w-[64px] text-[#222222]'>평일</span>
                    <strong className='font-[500]'>10:00~18:00</strong>
                  </p>
                  <p className='flex flex-wrap justify-start items-center'>
                    <span className='w-[64px] text-[#222222]'>점심시간</span>
                    <strong className='font-[500]'>13:00~14:00</strong>
                  </p>
                  <p className='flex flex-wrap justify-start items-center'>
                    <span className='w-[64px] text-[#222222]'>휴무</span>
                    <strong className='font-[500]'>주말 및 공휴일</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full'>
          <p className='text-[#222222] text-[11px] tracking-[-0.025em]'>
            Copyright ⓒ 한국영업경제인협회 DESIGNER ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
      {showButton && (
        <AnimatePresence mode='wait'>
          <motion.div
            variants={{
              hidden: { opacity: 0 },
              show: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.2,
                },
              },
            }}
            initial='hidden'
            animate='show'
            exit='hidden'
          >
            <button
              className='z-30 w-[40px] h-[40px] fixed bottom-[20px] right-[20px] bg-up-arrow bg-no-repeat bg-center bg-contain '
              onClick={() => goTop()}
            ></button>
          </motion.div>
        </AnimatePresence>
      )}
    </footer>
  );
}
